import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const SingleValueWrapper = styled(InnerComponent).attrs({ Component: components.SingleValue })`
  && {
    margin: 0 2px 0 0;
    height: 16px;
  }
`

const SingleValue = props => {
  return (
    <SingleValueWrapper {...props} />
  )
}

SingleValue.propTypes = {
  data: PropTypes.object,
  selectProps: PropTypes.object,
}

export default SingleValue
